const WORDS = ["Trust", "Vulnerability", "Connection", "Belonging", "Courage", "Honesty", "Presence"];

export default function Marquee() {
  const row = [...WORDS, ...WORDS];
  return (
    <section className="relative bg-sand-bg py-10 md:py-14 overflow-hidden select-none" data-testid="marquee-section">
      <div className="marquee-track">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-ink-text text-5xl md:text-7xl px-10 md:px-16">{w}</span>
            <span className="text-terra text-2xl md:text-4xl">✳</span>
          </span>
        ))}
      </div>
    </section>
  );
}
